var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8TestResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.002,
    height: 21.253,
    viewBox: "0 0 17.002 21.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-test-results",
    d: "M14.641,4a2.4,2.4,0,0,0-2.364,2.125H10.391A2.4,2.4,0,0,0,8,8.516V22.862a2.4,2.4,0,0,0,2.391,2.391h12.22A2.4,2.4,0,0,0,25,22.862V8.516a2.4,2.4,0,0,0-2.391-2.391H20.725A2.4,2.4,0,0,0,18.361,4Zm0,1.594h3.719a.8.8,0,1,1,0,1.594H14.641a.8.8,0,1,1,0-1.594ZM10.391,7.719h2.268a2.4,2.4,0,0,0,1.982,1.063h3.719a2.4,2.4,0,0,0,1.982-1.063h2.268a.785.785,0,0,1,.8.8V22.862a.785.785,0,0,1-.8.8H10.391a.785.785,0,0,1-.8-.8V8.516A.785.785,0,0,1,10.391,7.719ZM11.985,12.5a.8.8,0,1,0,0,1.594H17.3a.8.8,0,1,0,0-1.594Zm7.97,0a.8.8,0,1,0,0,1.594h1.063a.8.8,0,1,0,0-1.594Zm-7.97,3.188a.8.8,0,1,0,0,1.594H17.3a.8.8,0,1,0,0-1.594Zm7.97,0a.8.8,0,1,0,0,1.594h1.063a.8.8,0,1,0,0-1.594Zm-7.97,3.188a.8.8,0,1,0,0,1.594H17.3a.8.8,0,1,0,0-1.594Zm7.97,0a.8.8,0,1,0,0,1.594h1.063a.8.8,0,1,0,0-1.594Z",
    transform: "translate(-8 -4)",
    fill: "#6e6e72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TestResults);
export default __webpack_public_path__ + "static/media/icons8-test-results.27a48d99.svg";
export { ForwardRef as ReactComponent };